// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/af79204f6dccfefbb624.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"bdcedbdb89f69f5a8593","172":"18fc4f381581677228df","173":"c2a07d8ebf10e491943b"}[chunkId] + ".chunk.js";
};